// Changelog
// YYYYMMDD-<Card>-<Dev id>-<Abstract>
// 20171201-1030-Domenico De Felice-Added new bonus fields
// 20171004-784-Domenico & Kim--SO Uplift on predefined channels only
//
var calculationTableBind = { table: '=', data: '=', parent: '=' };
var CalculationTableController = (function () {
    function CalculationTableController($state, settings, env, socket, $scope, Dialog, admin) {
        this.$state = $state;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.admin = admin;
        switch (this.table) {
            case 0:
                // Card 1030 start
                this.headers = 'Priority,Country,License,Revenue Stream Code,GOE,Incentive,ISU,Material,Customer Designation,Bonus,Start\u00A0Date,End\u00A0Date,BP\u00A0id,IBM\u00A0id,Solution,New\u00A0Client,Focus,Growth,Sales,Engagement,CTL\u00A0incentive'.split(',');
                this.columns = 'Priority,Country,License,Revenue_Stream_Code,GOE,Incentive,ISU,Material,Customer_Designation,Bonus,StartDate,EndDate,bpid,ibmid,solution,newclient,focus,growth,sales,engagement,ctl'.toUpperCase().split(',');
                // Card 1030 end
                break;
            case 1:
                // Card 1030 start
                this.headers = 'Priority,Country,License,GOE,Incentive,ISU,Material,Customer Designation,Bonus,Start Date,End Date,BP id,IBM id,Solution,New Client'.split(',');
                this.columns = 'Priority,Country,License,GOE,Incentive,ISU,Material,Customer_Designation,Bonus,StartDate,EndDate,bpid,ibmid,solution,newclient'.toUpperCase().split(',');
                // Card 1030 end
                break;
            case 2:
                this.headers = 'Priority,IOT,Country,ISU,Channel,Line of Business,Licence,Customer Designation,Uplift,Start Date,End Date'.split(',');
                this.columns = 'Priority,IOT,Country,ISU,Channel,Lob,LICENCE_TYPE,CUSTOMER_DESIGNATION,Uplift,StartDate,EndDate'.toUpperCase().split(',');
                break;
            case 3:
                this.headers = 'Priority,IOT,Country,ISU,Channel,Line of Business,Licence,Customer Designation,Uplift,Start Date,End Date'.split(',');
                this.columns = 'Priority,IOT,Country,ISU,Channel,Lob,LICENCE_TYPE,CUSTOMER_DESIGNATION,Uplift,StartDate,EndDate'.toUpperCase().split(',');
                break;
            case 4:
                this.headers = 'Country,License,Incentive,Uplift,Start Date,End Date'.split(',');
                this.columns = 'Country,License,Incentive,Uplift,StartDate,EndDate'.toUpperCase().split(',');
                break;
            case 5:
                this.headers = 'Channel,Start Date,End Date'.split(','); // Card 784
                this.columns = 'Channel,StartDate,EndDate'.toUpperCase().split(','); // Card 784
                break;
            case 6:
                this.headers = 'Currency,USD to Local,Local to USD,Start Date, End Date'.split(',');
                this.columns = 'Currency,fromUsd,toUsd,StartDate,EndDate'.toUpperCase().split(',');
                break;
            default:
                this.headers = [];
                this.columns = [];
                break;
        }
        this.countries = this.settings.country_list.filter(function (item) {
            return item.ic === 'Country';
        }).sort(function (a, b) {
            return (a.country > b.country) ? 1 : ((b.country > a.country) ? -1 : 0);
        });
        this.selectedCountry = this.countries[0];
    }
    CalculationTableController.$inject = ['$state', 'settings', 'env', 'socket', '$scope', 'Dialog', 'admin'];
    return CalculationTableController;
}());
var CalculationTableComponent = (function () {
    function CalculationTableComponent() {
        this.bindings = calculationTableBind;
        this.templateUrl = 'calculation-table-view.html';
        this.controllerAs = 'vm';
        this.controller = CalculationTableController;
    }
    return CalculationTableComponent;
}());
angular
    .module('application')
    .component('calculationTableSection', new CalculationTableComponent());

//# sourceMappingURL=calculation.table.component.js.map
